export default __webpack_public_path__ + "static/media/TheElements _03.911ee3b8.png";